import { BaseModel, ModelInstance, ToFrontHook, ToBackHook } from './util';
import { Organization } from './organization';
import { Sport } from './sport';


@ModelInstance({
  mappingFields: {
    id: 'id',
    organization: 'organization',
    price: 'price',
    sport: 'sport',
  },
  relation: {
    organization: Organization,
    sport: Sport,
  }
})
export class OrganizationTariff extends BaseModel {
  id: number;
  organization: Organization;
  sport: Sport;
  price: number;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
